export const isFunction = <TArgs extends unknown[], TReturn>(
  fn: unknown,
): fn is (...args: TArgs) => TReturn => typeof fn === 'function';
